export default __webpack_public_path__ + "static/media/bird1.7819b8cf.svg";